import axios, { AxiosError } from 'axios'

// eslint-disable-next-line import/prefer-default-export
export function isAxiosError<T = unknown>(error: unknown): error is AxiosError<T> {
  return axios.isAxiosError<T>(error)
}
